import { Autocomplete, SxProps, TextField } from '@mui/material'
import React from 'react'

export interface CustomAutoCompleteProps {
    id: string,
    options: string[],
    handleOnInputChangeSearch: (event: React.SyntheticEvent, value: string) => void,
    onHandleKeyDown: (event: any) => void, 
    inputLabel: string,
    autoCompleteSxProps?: SxProps;
  }

export const CustomAutoComplete = ({id, options, handleOnInputChangeSearch, onHandleKeyDown, inputLabel, autoCompleteSxProps}: CustomAutoCompleteProps ) => {

   const autoCompleteSxPropsFinal: SxProps = {
        '& + .MuiAutocomplete-popper .MuiAutocomplete-option': {          
        '&:hover':{background: '#333333'},
        '&.Mui-focusVisible': {
            backgroundColor: '#333333',
        }},
        ...autoCompleteSxProps
   };
  return (
    <Autocomplete
        freeSolo
        id={id}
        data-testid={`${id}TestId`}
        data-trackid={`${id}TestId`}
        options={options}
        disableClearable
        autoSelect={false}
        disablePortal
        sx={autoCompleteSxPropsFinal}
        onInputChange={handleOnInputChangeSearch}
        onKeyDown={onHandleKeyDown}
        selectOnFocus
        blurOnSelect
        renderInput={(params) => (
        <TextField
            {...params}
            data-testid={`${id}TextFieldTestId`}
            data-trackid={`${id}TextFieldTestId`}
            label={inputLabel}
            InputProps={{
            ...params.InputProps,
            type: 'search',
            }}
        />
        )}
    />   
  )
}
